<template>
	<v-card class="padding">
        <v-dialog v-model="dialog" width="900">
            <v-card style="padding:10px;">
                <v-text-field label="Nome do grupo" color="blue-grey" v-model="descricaoGrupo"></v-text-field>
                <v-data-table
                  class="elevation-1"
                  :headers="headers"
                  :items="getPermissoes"
                  hide-actions
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-left">{{ props.item.nome }}</td>
                        <td class="text-xs-left">
                            <p>
                            <v-switch color="teal darken-1" v-for="(a,i) in props.item.acoes" :key="i" :label="a.text" v-model="a.status" style="float:left;margin-right:20px"></v-switch>
                            </p>
                        </td>
                    </template>
                </v-data-table>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="cyan--text" flat :disabled="!descricaoGrupo" @click="enviar(getPermissoes[0].admin)" > Criar Grupo</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-btn @click="dialog=true" color="fundo" class="white--text"  v-if="$can('gruposempresa', 'cadastrargruposempresa')">Adicionar</v-btn>
        <v-tooltip color="blue-grey" v-if="!$can('gruposempresa', 'cadastrargruposempresa')" top>
            <v-btn slot="activator" color="fundo" :disabled="true">
                Adicionar
            </v-btn>
            <span class="subheading">Você não possui permissão de cadastrar grupos empresa</span>
        </v-tooltip>
        <v-card class="pa-2" color="grey lighten-4" style="margin-top:50px;" v-for="(g,i) in getGrupos" :key="i" v-if="$can('gruposempresa', 'listargruposempresa')">
            <v-text-field color="blue-grey" label="Nome do grupo" v-model="g.nome"></v-text-field>
            <v-data-table class="elevation-1" :headers="headers" :items="g.paginas" hide-actions >
                <template slot="items" slot-scope="props">
                    <td class="text-xs-left">{{ props.item.nome }}</td>
                    <td class="text-xs-left">
                        <p>
                            <v-switch color="teal darken-1" v-for="(a,i) in props.item.acoes" :key="i" :label="a.text" v-model="a.status" style="float:left;margin-right:20px"></v-switch>
                        </p>
                    </td>
                </template>
            </v-data-table>
            <v-btn class="white--text" color="fundo" :disabled="!g.nome" @click="update(g)" v-if="$can('gruposempresa', 'alterargruposempresa')">Atualizar</v-btn>
            <v-tooltip color="blue-grey" v-if="!$can('gruposempresa', 'alterargruposempresa')" top>
                <v-btn slot="activator" class="white--text" :disabled="true">
                    Atualizar
                </v-btn>
                <span class="subheading">Você não possui permissão de alterar grupos empresa</span>
            </v-tooltip>
            <v-btn color="error" :disabled="!g.nome" @click="trash(g)" v-if="$can('gruposempresa', 'removergruposempresa')">Excluir Grupo</v-btn>
            <v-tooltip color="blue-grey" v-if="!$can('gruposempresa', 'removergruposempresa')" top>
                <v-btn slot="activator" class="white--text" :disabled="true">
                    Excluir Grupo
                </v-btn>
                <span class="subheading">Você não possui permissão de alterar grupos empresa</span>
            </v-tooltip>
        </v-card>
        <h1 class="text-xs-center headline mt-5" v-if="!$can('gruposempresa', 'listargruposempresa')">Você não possui permissão de listar usuários</h1>
        <v-snackbar
        bottom
        right
        v-model="snackbar"
        color="fundo"
        >
        {{ mensagem }}
        <v-btn
            dark
            flat
            @click="snackbar = false"
        >
            <v-icon>close</v-icon>
        </v-btn>
        </v-snackbar>
    </v-card>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  export default {
    data () {
      return {
        dialog:false,
        snackbar: false,
        mensagem: '',
        descricaoGrupo:'',
        headers:[
          { text: 'Nome da página', value: 'nome',sortable: false },
          { text: 'Ações', value: 'acoes',sortable: false },
        ],

      }
    },
    mounted()
    {
      //carregar grupos
      //carregar pages admin
      this.listaPermissoes()
      this.listaGrupos()
    },
    computed: {
        ...mapGetters(['getPermissoes', 'getEmpresa', 'getGrupos']),
        ...mapGetters(['getAppID'])
    },
    methods:{
      ...mapActions(['listaPermissoes', 'cadastraGrupo', 'listaGrupos', 'alteraGrupo', 'deletaGrupo']),
      enviar(paginas)
      {

        let grupo = {
            paginas,
            nome:this.descricaoGrupo,
            empresa_id:this.getEmpresa._id,
            app_id: this.getAppID
        }

        this.cadastraGrupo(grupo).then(r => {
            this.dialog = false
            this.snackbar = true
            this.mensagem = r.message
            this.descricaoGrupo = ''
            this.listaGrupos()
        })

      },
      update(grupo)
      {
        this.alteraGrupo(grupo).then(r => {
            this.snackbar = true
            this.mensagem = r.message
            this.listaGrupos()
        })
      },
      trash( g )
      {
        if(confirm("Tem certeza?"))
        {
          this.deletaGrupo(g).then(r => {
            this.snackbar = true
            this.mensagem = r.message
            this.listaGrupos()
          })
        }
      },
    }
  }
</script>






// WEBPACK FOOTER //
// src/components/user/empresa/GruposEmpresa.vue